export const API_ADDRESS = process.env.VUE_APP_API_ADDRESS
export const WS_ADDRESS = `${API_ADDRESS.replace(/(http)(s)?:\/\//, 'ws$2://')}/socket`
export const API_ADDRESS_AP = process.env.VUE_APP_API_AP_ADRESS
export const API_ADDRESS_DOSTARTU = process.env.VUE_APP_API_DOSTARTU_ADDRESS
export const API_TIMEOUT = 80 * 1000
export const TRACKPOINT_TYPES = {
    start: 'STA',
    meta: 'MET',
    checkpoint: 'CHK',
    buffet: 'BUF',
    return: 'RET',
    change: 'CHA',
    fans: 'FAN',
    office: 'OFF',
    parking: 'PAR',
}